<template>
  <div class="flex align-center">
    <p class="label mr-2">{{ label + " :" }}</p>
    <p class="text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    text: [String, Number],
  },
};
</script>

<style scoped>
p {
  @apply mb-0;
}

.label {
  font-weight: 700;
}
</style>
